import React from 'react';
import { useNavigate } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiArrowLeft } = FiIcons;

function AGB() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white text-stone-800">
      <header className="fixed top-0 left-0 right-0 bg-white/90 backdrop-blur-md z-40 border-b border-stone-50">
        <div className="max-w-5xl mx-auto px-6 py-4 flex items-center gap-4">
          <button onClick={() => navigate('/')} className="p-2 hover:bg-stone-50 rounded-full transition-colors group">
            <SafeIcon icon={FiArrowLeft} className="w-5 h-5 text-stone-600 group-hover:text-stone-900" />
          </button>
          <h1 className="text-xl font-light tracking-tight text-stone-900">
            Mind Your Nature
          </h1>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 pt-32 pb-20">
        <h2 className="text-3xl font-light mb-12 text-stone-900">Allgemeine Geschäftsbedingungen</h2>

        <div className="space-y-8 font-light text-stone-600 leading-relaxed text-sm">
          <div>
            <p className="text-xs text-stone-400">für das Format „Mind Your Nature" — gültig ab 01.01.2026</p>
          </div>

          <div>
            <h6 className="font-medium text-stone-900 mb-2">1. Anbieter und Geltungsbereich</h6>
            <p className="mb-3">Diese Allgemeinen Geschäftsbedingungen gelten für die Teilnahme an dem Format „Mind Your Nature", angeboten durch:</p>
            <p className="mb-3">
              Nadine Rau u. Mike Trepte GbR<br />
              Bettenhäuserstr. 1<br />
              34123 Kassel<br />
              Deutschland<br /><br />
              E-Mail: mike.trepte@underopensky.de<br />
              Telefon: 0561 / 43027276
            </p>
            <p className="mb-2">Die AGB gelten für alle Verträge zwischen dem Anbieter und Verbraucherinnen und Verbrauchern (§ 13 BGB), die die Teilnahme an „Mind Your Nature" betreffen.</p>
            <p>Abweichende Bedingungen der Teilnehmenden finden keine Anwendung.</p>
          </div>

          <div>
            <h6 className="font-medium text-stone-900 mb-2">2. Vertragsgegenstand</h6>
            <p className="mb-3">„Mind Your Nature" ist ein mehrtägiges Erfahrungsformat zur Wahrnehmung eigener innerer Prozesse in einem naturbasierten Rahmen.</p>
            <p className="mb-3">Gegenstand des Vertrages ist ausschließlich die Bereitstellung eines strukturierten Rahmens und die Begleitung des Formats.</p>
            <p className="mb-2">Nicht Bestandteil des Vertrags sind insbesondere:</p>
            <ul className="list-disc list-inside space-y-1 text-stone-500 ml-2">
              <li>Coaching</li>
              <li>Therapie oder therapeutische Leistungen</li>
              <li>medizinische oder psychologische Beratung</li>
              <li>Unterkunft</li>
              <li>Verpflegung</li>
              <li>An- oder Abreise</li>
            </ul>
          </div>

          <div>
            <h6 className="font-medium text-stone-900 mb-2">3. Buchung und Vertragsabschluss</h6>
            <p className="mb-2">Die Buchung erfolgt über externe Buchungsplattformen (z. B. Eventbrite) oder über Partnerportale.</p>
            <p className="mb-2">Mit Abschluss der Buchung kommt ein Vertrag zwischen der teilnehmenden Person und dem Anbieter zustande.</p>
            <p>Zusätzlich gelten die Allgemeinen Geschäftsbedingungen und Nutzungsbedingungen der jeweiligen Buchungsplattform. Im Falle von Widersprüchen haben die AGB der Plattform Vorrang für den Buchungsvorgang, diese AGB gelten ergänzend für die Durchführung des Formats.</p>
          </div>

          <div>
            <h6 className="font-medium text-stone-900 mb-2">4. Unterkunft und Verpflegung</h6>
            <p className="mb-2">Unterkunft und Verpflegung sind nicht Bestandteil der angebotenen Leistung.</p>
            <p className="mb-2">Die Buchung einer Unterkunft erfolgt eigenverantwortlich und direkt zwischen der teilnehmenden Person und dem jeweiligen Unterkunftsanbieter.</p>
            <p className="mb-2">Für Verpflegung sorgt jede teilnehmende Person selbst.</p>
            <p>Für Leistungen Dritter (Unterkunft, Verpflegung, sonstige Angebote) übernimmt der Anbieter keine Haftung.</p>
          </div>

          <div>
            <h6 className="font-medium text-stone-900 mb-2">5. Teilnahmevoraussetzungen und Eigenverantwortung</h6>
            <p className="mb-3">Die Teilnahme erfolgt auf eigene Verantwortung.</p>
            <p className="mb-3">Es wird ausdrücklich darauf hingewiesen, dass:</p>
            <ul className="list-disc list-inside space-y-1 text-stone-500 mb-3 ml-2">
              <li>keine Unfallversicherung gestellt wird</li>
              <li>keine Haftung für gesundheitliche oder körperliche Beeinträchtigungen übernommen wird</li>
              <li>die Teilnahme auch bei Aktivitäten im Freien auf eigene Gefahr erfolgt</li>
            </ul>
            <p>Die teilnehmende Person erklärt mit der Buchung, körperlich und psychisch in der Lage zu sein, an einem mehrtägigen Format in der Natur eigenverantwortlich teilzunehmen.</p>
          </div>

          <div>
            <h6 className="font-medium text-stone-900 mb-2">6. Haftung</h6>
            <p className="mb-2">Der Anbieter haftet nur für Schäden, die auf vorsätzlicher oder grob fahrlässiger Pflichtverletzung beruhen.</p>
            <p className="mb-2">Für leichte Fahrlässigkeit haftet der Anbieter nur bei Verletzung wesentlicher Vertragspflichten (Kardinalpflichten), begrenzt auf den vertragstypischen, vorhersehbaren Schaden.</p>
            <p>Eine Haftung für Schäden an Leben, Körper oder Gesundheit bleibt unberührt.</p>
          </div>

          <div>
            <h6 className="font-medium text-stone-900 mb-2">7. Höhere Gewalt</h6>
            <p className="mb-3">Der Anbieter ist berechtigt, das Format ganz oder teilweise abzusagen oder abzubrechen, wenn Ereignisse höherer Gewalt eintreten. Dazu zählen insbesondere:</p>
            <ul className="list-disc list-inside space-y-1 text-stone-500 mb-3 ml-2">
              <li>extreme Wetterbedingungen</li>
              <li>behördliche Anordnungen</li>
              <li>Krankheit der Veranstalter</li>
              <li>sonstige unvorhersehbare, nicht zu vertretende Umstände</li>
            </ul>
            <p>In diesen Fällen besteht kein Anspruch auf weitergehenden Schadensersatz.</p>
          </div>

          <div>
            <h6 className="font-medium text-stone-900 mb-2">8. Rücktritt und Stornierung durch Teilnehmende</h6>
            <p className="mb-3">Es gelten folgende Stornierungsbedingungen für die Teilnahmegebühr:</p>
            <ul className="list-disc list-inside space-y-1 text-stone-500 mb-4 ml-2">
              <li>bis 30 Tage vor Beginn: kostenfreie Stornierung</li>
              <li>29 bis 15 Tage vor Beginn: 50 % der Teilnahmegebühr</li>
              <li>ab 14 Tage vor Beginn oder bei Nichterscheinen wird die Teilnahmegebühr in voller Höhe einbehalten</li>
            </ul>
            <p className="mb-3">Maßgeblich ist der Zeitpunkt des Eingangs der Stornierung in Textform beim Anbieter.</p>
            <p>Die von Eventbrite erhobenen Service- und Zahlungsgebühren sind nicht Bestandteil der Teilnahmegebühr und werden im Falle einer Stornierung nicht erstattet.</p>
          </div>

          <div>
            <h6 className="font-medium text-stone-900 mb-2">9. Ausschluss des Widerrufsrechts</h6>
            <p>Ein Widerrufsrecht besteht nicht gemäß § 312g Abs. 2 Nr. 9 BGB, da es sich um eine Dienstleistung im Zusammenhang mit Freizeitbetätigungen handelt, für die ein spezifischer Termin oder Zeitraum vorgesehen ist.</p>
          </div>

          <div>
            <h6 className="font-medium text-stone-900 mb-2">10. Bild- und Tonaufnahmen</h6>
            <p className="mb-2">Bild-, Ton- oder Videoaufnahmen während des Formats sind grundsätzlich untersagt.</p>
            <p className="mb-2">Ausnahmen sind nur zulässig, wenn alle beteiligten Personen, einschließlich der Veranstalter und aller Teilnehmenden, ausdrücklich zustimmen.</p>
            <p>Ein Anspruch auf Zustimmung besteht nicht.</p>
          </div>

          <div>
            <h6 className="font-medium text-stone-900 mb-2">11. Ausschluss von Personen</h6>
            <p>Der Anbieter behält sich vor, Teilnehmende vom Format auszuschließen, wenn deren Verhalten den Ablauf erheblich stört oder die Sicherheit anderer gefährdet. In diesem Fall besteht kein Anspruch auf Rückerstattung.</p>
          </div>

          <div>
            <h6 className="font-medium text-stone-900 mb-2">12. Schlussbestimmungen</h6>
            <p className="mb-2">Es gilt das Recht der Bundesrepublik Deutschland.</p>
            <p className="mb-2">Sollten einzelne Bestimmungen dieser AGB unwirksam sein oder werden, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.</p>
            <p>Gerichtsstand ist, soweit gesetzlich zulässig, Kassel.</p>
          </div>
        </div>
      </main>
    </div>
  );
}

export default AGB;